import ThankYouPage from '@screens/review-section2/thank-you/thank-you-page';
import {
    createLoaderService,
    createSection2ThankyouStore
} from '@services/factories';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';

@observer
class Section2ThankYou extends React.Component<RouteComponentProps> {
    // Probably good idea to dependency inject these later
    loaderService = createLoaderService();
    store = createSection2ThankyouStore();

    // Phase 1: Disabled determining feedback message until requirements are worked out
    // async componentDidMount() {
    //     this.loaderService.showLoader();
    //     await this.store.fetchI9Status();
    //     this.loaderService.hideLoader();
    // }

    render() {
        return (
            <ThankYouPage store={this.store} />
        );
    }
}

export default Section2ThankYou;



// WEBPACK FOOTER //
// ./src/screens/review-section2/thank-you/index.tsx